var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DOMcreateElement, DOMcreateFragment } from '../typescript/TSXDomParse';
import NavLink from './NavLink';
import NavColumnComponents from './NavColumnComponents';
import { notNullAndLengthy } from '../typescript/helpers';
import { headerContentType } from '../typescript/constants';
import ConditionalWrapper from './ConditionalWrapper';
export default function LinkList(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var component = _a.component, level = _a.level, clickFunction = _a.clickFunction, isMobile = _a.isMobile;
    var components = (_b = component.fields) === null || _b === void 0 ? void 0 : _b.components;
    /*
     * Currently, header links ('componentLinkBig') and
     * chils navigation links ('componentLinkSmall') exist in the same
     * heirarchy in the contentful data.
     * e.g. [ 'componentLinkBig', 'componentLinkSmall' ]
     * instead of
     * [{
     *      'componentLinkBig',
     *       children: [
     *          'componentLinkSmall',
     *          'componentLinkSmall',
     *          'componentLinkSmall',
     *      ]
     * }]
     *
     * This function nests the children underneath the parent link
     *
     */
    var flatMapToMenu = [];
    var flatObject = {
        text: '',
        children: [],
    };
    if (components) {
        for (var _i = 0, components_1 = components; _i < components_1.length; _i++) {
            var component_1 = components_1[_i];
            var contentTypeId = (_e = (_d = (_c = component_1.sys) === null || _c === void 0 ? void 0 : _c.contentType) === null || _d === void 0 ? void 0 : _d.sys) === null || _e === void 0 ? void 0 : _e.id;
            if (contentTypeId === headerContentType) {
                flatObject = {
                    text: (_f = component_1.fields) === null || _f === void 0 ? void 0 : _f.text,
                    children: [],
                    type: (_j = (_h = (_g = component_1.sys) === null || _g === void 0 ? void 0 : _g.contentType) === null || _h === void 0 ? void 0 : _h.sys) === null || _j === void 0 ? void 0 : _j.id,
                };
                if ((_k = component_1.fields) === null || _k === void 0 ? void 0 : _k.url)
                    flatObject.url = component_1.fields.url;
                flatMapToMenu.push(flatObject);
            }
            else {
                flatObject.children.push(component_1);
            }
        }
    }
    if (!flatMapToMenu.length)
        flatMapToMenu.push({ children: components });
    return (DOMcreateElement(DOMcreateFragment, null, flatMapToMenu.map(function (menu) { return (DOMcreateElement(DOMcreateFragment, null,
        notNullAndLengthy(menu.text) ? (DOMcreateElement(NavLink, __assign({ onClick: clickFunction, text: menu.text, type: menu.type }, (menu.url ? { url: menu.url } : {}), { level: level + 1, expandable: notNullAndLengthy(menu.children) }))) : (''),
        notNullAndLengthy(menu.children) ? (DOMcreateElement(Children, { isMobile: isMobile, level: level + 1, component: component, menu: menu })) : (''))); })));
}
function Children(_a) {
    var menu = _a.menu, component = _a.component, level = _a.level, isMobile = _a.isMobile;
    var childMap = menu.children.map(function (c) {
        var _a, _b, _c, _d, _e, _f;
        if (((_c = (_b = (_a = component.sys) === null || _a === void 0 ? void 0 : _a.contentType) === null || _b === void 0 ? void 0 : _b.sys) === null || _c === void 0 ? void 0 : _c.id) === headerContentType) {
            return (DOMcreateElement(DOMcreateFragment, null,
                DOMcreateElement(NavLink, __assign({ level: level, expandable: notNullAndLengthy(menu.text), text: (_d = component.fields) === null || _d === void 0 ? void 0 : _d.titleOfComponent }, (((_f = (_e = c.fields) === null || _e === void 0 ? void 0 : _e.url) === null || _f === void 0 ? void 0 : _f.length) > 0
                    ? {
                        url: c.fields.url,
                    }
                    : {})))));
        }
        else {
            return (DOMcreateElement(NavColumnComponents, { component: c, level: level, isNested: notNullAndLengthy(menu.text) }));
        }
    });
    return (DOMcreateElement(ConditionalWrapper, { condition: isMobile, wrapper: function (children) { return (DOMcreateElement("div", { className: "dropdown-wrapper" }, children)); } },
        DOMcreateElement("ul", { className: "children" }, childMap)));
}
